import { VNode } from 'vue'
import { Component } from 'vue-property-decorator'
import $style from './index.module.scss'
import { Form, FormItem, Input, Link, Image } from 'element-ui'
import Controller from './controller'

@Component({
  components: {
    [Form.name]: Form,
    [Input.name]: Input,
    [FormItem.name]: FormItem,
    [Link.name]: Link,
    [Image.name]: Image
  }
})
export default class LoginView extends Controller {
  render(): VNode {
    return <div class={$style.login_viewport}>
      <div class='login-panel'>
        <div class="logo"></div>
        <div class="form-wrapper">
          <div class="title">Welcome，唯寻教育大中台</div>
          {/* 登录模块 */}
          { !this.modifyPasswordTip &&
            <div onKeyup={this.handleEnterKey}>
              <el-form ref='refForm' props={{ model: this.formData, rules: this.rules }} class='my-form'>
                <el-form-item prop='userName'>
                  <el-input v-model={this.formData.userName} placeholder='请输入工号, 例: VA100000'></el-input>
                </el-form-item>
                <el-form-item prop='password'>
                  <el-input v-model={this.formData.password} type='password' placeholder='请输入登录密码'></el-input>
                </el-form-item>
                <el-form-item prop='captchaInput' class='captcha-item'>
                  <div class='captcha-row'>
                    <el-input
                      v-model={this.formData.captchaInput}
                      placeholder='请输入验证码'
                      maxlength={4}
                      autocomplete='off'
                      class='captcha-input'
                    ></el-input>
                    <canvas ref='captchaCanvas' width={120} height={40} class='captcha-canvas'></canvas>
                  </div>
                </el-form-item>
              </el-form>
              <div class={`btn-login${this.loging ? ' loading' : ''}`} onClick={ this.login }>
                { this.loging ? <i class="el-icon-loading"></i> : null }
                登 录
              </div>
              <div class="bottom-tip">
                <span>没有帐号或忘记密码？</span>
                <div class="operator-links">
                  <el-link type="primary" onClick={ this.handleLinkClick.bind(null, 'full') } underline={ false }>全职员工</el-link>
                  <el-link type="primary" onClick={ this.handleLinkClick.bind(null, 'part') } underline={ false }>兼职员工</el-link>
                </div>
              </div>
            </div>
          }
          {/* 全职员工账号信息 */}
          { this.modifyPasswordTip === 'full' &&
            <div class="employee-tip">
              <div class="header">
                <span class="go-back">
                  <i class="el-icon-back" onClick={ this.goBack.bind(null) } />
                  全职员工
                </span>
                {/* <span class="tip">用户不存在：请联系技术支持(VA100884)</span> */}
              </div>
              <div class="content">
                <el-image src="https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/7129/7ca4/4487/95f98cfe-7844-4ac7-9217-14236f50f112">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <p>请您使用手机，打开 <span>钉钉后扫码</span></p>
              </div>
            </div>
          }
          {/* 兼职员工账号信息 */}
          { this.modifyPasswordTip === 'part' &&
            <div class="employee-tip">
              <div class="header">
                <span class="go-back">
                  <i class="el-icon-back" onClick={ this.goBack.bind(null) } />
                  兼职员工
                </span>
                {/* <span class="tip">用户不存在：请联系技术支持(VA100884)</span> */}
              </div>
              <div class="content">
                <p>请联系您的HRBP老师</p>
                {/* <p>请联系您的HRBP老师，与技术支持</p> */}
                {/* <p>(VA100884)沟通并告知账号原因</p> */}
              </div>
            </div>
          }
          <div class="copy-right">上海唯寻教育科技有限公司 I Copyright 2021 I All Right Reserverd I 沪ICP备18045704号-2</div>
        </div>
      </div>
    </div>
  }
}
